module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/5S9lZyvzQkSY8mgWgSi2kk-8587f5fc7a98c09292bc9c46f1082a4a.jpg";